import { render } from "./InputCoordinatesModal.vue?vue&type=template&id=d54dc4b6"
import script from "./InputCoordinatesModal.vue?vue&type=script&lang=js"
export * from "./InputCoordinatesModal.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/htdocs/cgeolink/src/front/cgeolink/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__